export const FONT_SIZES = [12, 14, 16, 18, 20];
export const COLORS = ['white', 'black', 'lightGrey', 'mediumGrey', 'cyan'];
